import { action, observable, runInAction } from "mobx";
import { BaseViewStore, BaasicDropdownStore } from "core/stores";
import { ItemSubcategoryService } from "application/facility-order/services";
import { SubCategoryService } from "application/product/services";
import { LookupService } from "common/services";
import _ from "lodash";
import { uuid } from "core/utils";
import { ModalParams } from "core/models";
import { subCategoriesSort } from "core/utils";
import { NikoPatientTemplateItemService } from "../services";
import { FacilityOrderService } from "application/facility-order/services";
class NikoTemplateCreateViewStore extends BaseViewStore {
  @observable accessor itemCategory = "";
  @observable accessor productStore;
  @observable accessor disabledTable = false;
  @observable accessor isSystemDns = false;
  @observable accessor isUserDns = false;
  @observable accessor missingProductNote = "";
  @observable accessor isAddingNote = false;
  @observable accessor patientTemplateItems;

  constructor(rootStore, componentsProps) {
    super(rootStore);

    this.rootStore = rootStore;

    this.form = componentsProps.form;
    this.patientTemplateItems = componentsProps.patientTemplateItems;
    this.patientTemplateTrachItems = componentsProps.patientTemplateTrachItems;

    this.facilityId = componentsProps.facilityId;
    this.facilityOrderId = componentsProps.facilityOrderId;
    this.pageType = componentsProps.pageType || null;
    this.onSubCategoryChange = componentsProps.onSubCategoryChange;

    this.subCategoryService = new SubCategoryService(rootStore.application.baasic.apiClient);
    this.itemSubcategoryService = new ItemSubcategoryService(rootStore.application.baasic.apiClient);
    this.patientTemplateItemService = new NikoPatientTemplateItemService(rootStore.application.baasic.apiClient);
    this.facilityOrderService = new FacilityOrderService(rootStore.application.baasic.apiClient);

    this.subCategoryStore = new BaasicDropdownStore(
      {},
      {
        fetchFunc: async (term) => {
          const facilityOrder = (await this.facilityOrderService.get(this.facilityOrderId)).data;

          const subCategorysAbrv = (facilityOrder && facilityOrder.isEnteralWeek) ? ["G-Tube", "Oral-Supplements", "Enteral"] : ["G-Tube", "Oral-Supplements", "Enteral", "Respiratory---trachs-supply", "Trach-Tube", "Urologicals", "Ostomy-Products"];

          const response = await this.subCategoryService.find({ searchQuery: term, rpp: 100, sort: "itemCategory.name|asc", embed: "ItemCategory" });

          let data = subCategoriesSort(
            response.data.item.map((i) => {
              return { ...i, name: `${i.name}` };
            })
          );

          let filteredSubCategories = _.filter(data, (i) => {
            return subCategorysAbrv.some((s) => i.abrv === s);
          });
          return filteredSubCategories;
        },
        onChange: async () => {
          this.setItemCatrgory();
          await this.setProductStore();
          if (this.onSubCategoryChange) {
            await this.onSubCategoryChange(this.subCategoryStore.value);
          }

          if (this.patientTemplateItems && this.patientTemplateItems.splice) {
            this.patientTemplateItems.splice(0);
          }

          if (this.patientTemplateTrachItems && this.patientTemplateTrachItems.splice) {
            this.patientTemplateTrachItems.splice(0);
          }

          if (this.patientTemplateItems.length === 0) {
            this.addEmptyItem(this.patientTemplateItems);
          }
        },
      }
    );

    this.nikoPatientTemplateItemCalculationModal = new ModalParams({});
    this.facilityOrderTemplateItemNewFlowNoteModal = new ModalParams({});
    this.missingProductNoteModal = new ModalParams({});
    this.doNotSupplyModal = new ModalParams({});

    this.fetch([this.initialize()]);
  }

  @action.bound
  async initialize() {
    await this.getLookups();
    await this.addEmptyItem(this.patientTemplateItems);
    this.form.clear();
  }

  @action.bound
  async getLookups() {
    const lookupService = new LookupService(this.rootStore.application.baasic.apiClient);
    const response = await lookupService.getLookups("ImportAction,ItemCategory,SubCategory");
    runInAction(() => {
      this.importActions = response.importAction;
      this.itemCategories = response.itemCategory;
      this.subCategories = response.subCategory;
    });
  }

  @action.bound
  async addEmptyItem(patientTemplateItems) {
    await this.setProductStore();

    patientTemplateItems.push({
      id: uuid(),
      note: undefined,
      product: null,
      productId: null,
      procedureCode: null,
      mlph: undefined,
      frequency: undefined,
      itemCals: 0,
      itemMls: 0,
      quantity: 0,
      salesOrderQuantity: 0,
      action: this.importActions.find((x) => x.abrv == "insert"),
      actionId: this.importActions.find((x) => x.abrv == "insert").id,
    });
  }

  @action.bound
  async addItem(patientTemplateItems, items, index) {
    this.disabledTable = true;
    patientTemplateItems.splice(index);
    _.each(items, i => {
      let patientTemplateItem = patientTemplateItems.find(x => x.id === i.id);
      if (patientTemplateItem) {
        patientTemplateItem.procedureCode = i.procedureCode;
      }
      else {
        patientTemplateItems.push(
          {
            id: i.id,
            note: i.note || undefined,
            product: i.product,
            productId: i.product && i.product.id,
            procedureCode: i.procedureCode,
            mlph: i.mlph,
            frequency: i.frequency,
            itemCals: i.itemCals,
            itemMls: i.itemMls,
            quantity: i.quantity,
            salesOrderQuantity: i.salesOrderQuantity,
          });
      }
    });

    this.addEmptyItem(patientTemplateItems);
    this.disabledTable = false;
  }

  @action.bound
  async deleteItem(patientTemplateItems, index) {
    this.disabledTable = true;
    patientTemplateItems.splice(index, 1);

    if (patientTemplateItems.length === 0) {
      this.addEmptyItem(patientTemplateItems);
    }
    this.disabledTable = false;
  }

  @action.bound
  editItem(patientTemplateItems, index, value, propertyName) {
    this.disabledTable = true;
    patientTemplateItems[index][propertyName] = value;
    if (propertyName === "quantity") {
      patientTemplateItems[index]["salesOrderQuantity"] = value;
    }
    this.disabledTable = false;
  }

  @action.bound
  async saveItem(patientTemplateItems, index, product) {
    this.disabledTable = true;
    let tempItem = {
      product: product,
      productId: product.id,
      procedureCode: product.procedureCode_ && product.procedureCode_.abrv
    };

    const isEnteral = this.itemCategory && patientTemplateItems !== this.patientTemplateTrachItems
    const isFormula = (product.itemType && (product.itemType.abrv === "bottle" || product.itemType.abrv === "can")) || (product.procedureCode_ && product.procedureCode_.abrv === "B4155");
    if (isEnteral && isFormula) {
      _.extend(tempItem, { itemMls: 1, itemCals: product.calsPerMl });
    }

    try {
      const response = (await this.patientTemplateItemService.createAdditionalItems(
        {
          patientTemplateItem: tempItem,
          patientTemplateItems: patientTemplateItems.filter((i) => i.product).map((i) => { return { id: i.id, product: i.product, productId: i.productId, procedureCode: i.procedureCode, importActionId: i.importActionId }; }),
          subCategoryId: this.subCategoryStore.value.id,
          facilityId: this.facilityId,
        }
      )).data;

      if (tempItem.product.innerCannulaId && patientTemplateItems != this.patientTemplateTrachItems) {
        const responseTrach = (await this.patientTemplateItemService.createAdditionalTrachItems(
          {
            patientTemplateItem: tempItem,
            subCategoryId: this.subCategoryStore.value && this.subCategoryStore.value.id,
          })).data;
        this.addItem(this.patientTemplateTrachItems, responseTrach, index);
      }

      this.addItem(patientTemplateItems, response, index);
      if (isEnteral && isFormula) {
        index = patientTemplateItems.indexOf(patientTemplateItems.slice(index).find(i => i.product.id == tempItem.productId));
        this.openNikoPatientTemplateItemCalculationModal(patientTemplateItems, index);
      }
    } catch (err) {
      this.rootStore.notificationStore.error(err.data ? err.data : "Error while adding additional items");
    } finally {
      this.disabledTable = false;
    }
  }

  @action.bound
  async setProductStore() {
    const ostomySubCategory = this.subCategories.find((x) => x.abrv == "Ostomy-Products");
    const isOstomySubCategory = this.subCategoryStore.value && this.subCategoryStore.value.id === ostomySubCategory.id;

    this.productStore = new BaasicDropdownStore(
      {
        filterable: true,
        textField: "itemId",
      },
      {
        fetchFunc: async (term) => {
          if (!this.subCategoryStore.value) return [];

          let params = {
            searchQuery: term,
            rpp: 50,
            subCategoryId: this.subCategoryStore.value.id,
            isActive: true,
            embed: "Product,Product.ItemType,Product.ItemCategory,Product.SubCategory,Product.UnitOfMeasure,Product.ProcedureCode_",
          };

          if (isOstomySubCategory) {
            params = { ...params, sort: "isPreferred|desc" };
          }

          const response = await this.itemSubcategoryService.find(params);
          let filteredProducts = response.data.item.filter((x) => !x.product.itemId.toLowerCase().includes("-cs"));

          return _.map(filteredProducts, (item) => {
            return {
              ...item.product,
            };
          });
        },
      }
    );
  }

  @action.bound
  setItemCatrgory() {
    const oldItemCategory = this.itemCategory;
    this.itemCategory = this.subCategoryStore.value && this.subCategoryStore.value.itemCategory && this.subCategoryStore.value.itemCategory.abrv;

    if (oldItemCategory === "enteral" && oldItemCategory !== this.itemCategory) {
      _.each(this.patientTemplateItems, (item) => {
        item.mlph = undefined;
        item.frequency = undefined;
        item.itemCals = 0;
        item.itemMls = 0;
      });
    }
  }

  @action.bound
  openNikoPatientTemplateItemCalculationModal(patientTemplateItems, index) {
    this.nikoPatientTemplateItemCalculationModal.open({
      patientTemplateItem: patientTemplateItems[index],
      facilityId: this.facilityId,
      patientTemplateItemService: this.patientTemplateItemService
    });
  }

  @action.bound
  openFacilityOrderTemplateItemNewFlowNoteModal(patientTemplateItems, index) {
    this.facilityOrderTemplateItemNewFlowNoteModal.open({
      facilityOrderTemplateItem: patientTemplateItems[index],
    });
  }
}

export default NikoTemplateCreateViewStore;
